import BrandProvider from '../contexts/brand'
import { useState, type JSX } from 'react'
import Header from '../components/header'
import { useTranslation } from 'react-i18next'
import { Brand, BRANDS, DEFAULT_BRAND } from '../types/brand'

export function UnsupportedBrowser (): JSX.Element {
  const { t } = useTranslation()
  const [brand] = useState((): Brand => {
    const hostnameParts = location.hostname.split('.')
    const pathParts = location.pathname.split('/')
    return BRANDS.find(brand => hostnameParts.includes(brand) || pathParts.includes(brand)) ?? DEFAULT_BRAND
  })

  return (
    <BrandProvider brand={brand}>
      <div className='grid' data-brand={brand}>
        <div className='flex flex-col accent-brand-primary brand-inselhuepfen:font-open-sans'>
          <Header />
          <main className='mb-16 lg:mb-8'>
            <div className='container mx-auto text-center'>
              <h1 className='text-3xl mt-8'>{t('unsupported_browser_title', 'Your browser is not supported.')}</h1>
              <p className='my-8'>{t('unsupported_browser_description', 'Please update your browser.')}</p>
            </div>
          </main>
        </div>
      </div>
    </BrandProvider>
  )
}
